'use client';

import { c as _c } from "react/compiler-runtime";
import { ShowMore, type ShowMoreProps, type ShowMoreRef } from '@re-dev/react-truncate';
import { type RefAttributes, useState } from 'react';
import { cn } from '@/lib/cn';
export interface ReadMoreStringProps extends Omit<ShowMoreProps, 'children' | 'more' | 'less' | 'anchorClass' | 'ref'>, RefAttributes<ShowMoreRef> {
  readMoreClassName?: string;
  readMoreLabel?: string;
  readLessLabel?: string;
  text: string;
}
export function ReadMoreString(t0) {
  const $ = _c(27);
  let className;
  let props;
  let readMoreClassName;
  let style;
  let t1;
  let t2;
  let t3;
  let text;
  if ($[0] !== t0) {
    ({
      className,
      text,
      lines: t1,
      readMoreClassName,
      readMoreLabel: t2,
      readLessLabel: t3,
      style,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = readMoreClassName;
    $[4] = style;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = text;
  } else {
    className = $[1];
    props = $[2];
    readMoreClassName = $[3];
    style = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    text = $[8];
  }
  const lines = t1 === undefined ? 2 : t1;
  const readMoreLabel = t2 === undefined ? "Read more" : t2;
  const readLessLabel = t3 === undefined ? "Hide more" : t3;
  const [doClamp, setDoClamp] = useState(true);
  let t4;
  if ($[9] !== className || $[10] !== doClamp) {
    t4 = cn({
      "line-clamp-(--line-clamp) ": doClamp
    }, className);
    $[9] = className;
    $[10] = doClamp;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setDoClamp(false);
    };
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== readMoreClassName) {
    t6 = cn("animate-in fade-in", readMoreClassName);
    $[13] = readMoreClassName;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== lines || $[16] !== style) {
    t7 = {
      "--line-clamp": lines,
      ...style
    };
    $[15] = lines;
    $[16] = style;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== lines || $[19] !== props || $[20] !== readLessLabel || $[21] !== readMoreLabel || $[22] !== t4 || $[23] !== t6 || $[24] !== t7 || $[25] !== text) {
    t8 = <ShowMore lines={lines} more={readMoreLabel} less={readLessLabel} className={t4} onTruncate={t5} anchorClass={t6} style={t7} {...props}>{text}</ShowMore>;
    $[18] = lines;
    $[19] = props;
    $[20] = readLessLabel;
    $[21] = readMoreLabel;
    $[22] = t4;
    $[23] = t6;
    $[24] = t7;
    $[25] = text;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
}